import { pick } from "lodash";
import { SERVER_METHODS, requestServer } from "./request";
import ApplicationError from "../utils/ApplicationError";
var CryptoJS = require("crypto-js");

export const login = async (user) => {
  const path = "/login";
  try {
    let res = await requestServer(
      SERVER_METHODS.POST,
      path,
      { auth: pick(user, ["email", "password"]), stay_loggedin: false, type: "elsa" }

    );
    if (res.status === 200) {
      return await res.json();
    } else {
      throw new ApplicationError(res.status, await res.json());
    }
  } catch (error) {
    console.log(error);
    if (error instanceof ApplicationError) throw error;
    else throw JSON.stringify({ code: "INT", info: "OTHER ERROR" });
  }
};

export const logout = async () => {
  const path = "/logout";
  try {
    let res = await requestServer(SERVER_METHODS.POST, path);
    if (res.status === 200) {
      return await res.json();
    } else {
      throw new ApplicationError(res.status, await res.json());
    }
  } catch (error) {
    console.log(error);
    if (error instanceof ApplicationError) throw error;
    else throw JSON.stringify({ code: "INT", info: "OTHER ERROR" });
  }
};

export const signup = (user) => { };

export const getUserInfo = async () => {
  const path = "/proxy/user/user_info";
  try {
    let res = await requestServer(SERVER_METHODS.GET, path);
    if (res.status === 200) {
      return await res.json();
    } else {
      throw new ApplicationError(res.status, await res.json());
    }
  } catch (error) {
    if (error instanceof ApplicationError) throw error;
    else throw JSON.stringify({ code: "INT", info: "OTHER ERROR" });
  }
};

export const changePassword = async (userObj) => {
  const path = "/proxy/user/reset-password";
  try {
    let res = await requestServer(SERVER_METHODS.POST, path, {
      oldPassword: CryptoJS.SHA1(userObj.old_password).toString(
        CryptoJS.enc.Base64
      ),
      newPassword: CryptoJS.SHA1(userObj.new_password).toString(
        CryptoJS.enc.Base64
      ),
    });
    if (res.status === 200) {
      return await res.json();
    } else {
      throw new ApplicationError(res.status, await res.json());
    }
  } catch (error) {
    if (error instanceof ApplicationError) throw error;
    else throw JSON.stringify({ code: "INT", info: "OTHER ERROR" });
  }
};

export const forgotPassword = async (email) => {
  const path = "/proxy/user/forgot-password";
  try {
    let res = await requestServer(SERVER_METHODS.POST, path, { email });
    if (res.status === 200) {
      return await res.json();
    } else {
      throw new ApplicationError(res.status, await res.json());
    }
  } catch (error) {
    if (error instanceof ApplicationError) throw error;
    else throw JSON.stringify({ code: "INT", info: "OTHER ERROR" });
  }
};

export const getUser = async (searchKey) => {
  const path = "/user/find_users";
  try {
    let res = await requestServer(SERVER_METHODS.POST, path, { searchKey });
    if (res.status === 200) {
      return await res.json();
    } else {
      throw new ApplicationError(res.status, await res.json());
    }
  } catch (error) {
    if (error instanceof ApplicationError) throw error;
    else throw JSON.stringify({ code: "INT", info: "OTHER ERROR" });
  }
};
